import {
  VENDOR_PRODUCTS_FAILED,
  VENDOR_PRODUCTS_SUCCESS,
  VENDOR_PRODUCTS_INVALID_REQUEST,
  VENDOR_PRODUCTS_NOT_FOUND,
  LOADING_VENDOR_PRODUCTS,
  RESET_VENDOR_PRODUCTS,
  DELETE_VP_SUCCESS,
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
  products: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_VENDOR_PRODUCTS:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        invalidRequest: false,
        notFound: false,
      };

    case VENDOR_PRODUCTS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        invalidRequest: false,
        notFound: false,
      };

    case VENDOR_PRODUCTS_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        notFound: false,
      };

    case VENDOR_PRODUCTS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        success: true,
        invalidRequest: false,
        failed: false,
        notFound: false,
        products: action.payload,
      };
    }

    case DELETE_VP_SUCCESS: {
      const { productId } = action.payload;

      return {
        ...state,
        products: state.products.filter((p) => p.productId !== productId),
      };
    }

    case VENDOR_PRODUCTS_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        notFound: true,
      };

    case RESET_VENDOR_PRODUCTS:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        notFound: false,
      };

    default:
      return state;
  }
};
